module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emplyee-manage"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "员工名称："
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.userName),
      callback: function($$v) {
        _vm.$set(_vm.query, "userName", $$v)
      },
      expression: "query.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作地："
    }
  }, [_c('el-select', {
    staticClass: "input-width",
    model: {
      value: (_vm.query.workAddress),
      callback: function($$v) {
        _vm.$set(_vm.query, "workAddress", $$v)
      },
      expression: "query.workAddress"
    }
  }, _vm._l((_vm.WorkAddress), function(item) {
    return _c('el-option', {
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属公司/中心/部门："
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": true
    },
    on: {
      "focus": _vm.changeCompany
    },
    model: {
      value: (_vm.query.d_name),
      callback: function($$v) {
        _vm.$set(_vm.query, "d_name", $$v)
      },
      expression: "query.d_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "员工属性："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "75%"
    },
    model: {
      value: (_vm.query.employeeProperty),
      callback: function($$v) {
        _vm.$set(_vm.query, "employeeProperty", $$v)
      },
      expression: "query.employeeProperty"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "全职员工"
    }
  }, [_vm._v("全职员工")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "兼职员工"
    }
  }, [_vm._v("兼职员工")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入职时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.query.entryStartDate),
      callback: function($$v) {
        _vm.$set(_vm.query, "entryStartDate", $$v)
      },
      expression: "query.entryStartDate"
    }
  }), _vm._v(" "), _c('span', [_vm._v("到")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.query.entryEndDate),
      callback: function($$v) {
        _vm.$set(_vm.query, "entryEndDate", $$v)
      },
      expression: "query.entryEndDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工龄："
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.workTime),
      callback: function($$v) {
        _vm.$set(_vm.query, "workTime", $$v)
      },
      expression: "query.workTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "正式员工"
    }
  }, [_vm._v("正式员工")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "试用期"
    }
  }, [_vm._v("试用期")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "实习"
    }
  }, [_vm._v("实习")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "离职"
    }
  }, [_vm._v("离职")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete"
    },
    on: {
      "click": _vm.onQueryClean
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.addHandle
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "icon": "delete"
    },
    on: {
      "click": _vm.deleteEmployee
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.lists,
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "55",
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "ID",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "EmpCode",
      "label": "雇员编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "RoleName",
      "label": "角色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "name",
      "label": "名字"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "prop": "sex",
      "label": "性别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "WorkAddress",
      "label": "工作地"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "CompanyName",
      "label": "所属公司"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "d_name",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "LineMange",
      "label": "直线经理"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "EmployeeProperty",
      "label": "员工属性"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "tel",
      "label": "手机"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "EntryDate",
      "label": "入职日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "birthday",
      "label": "生日"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "prop": "WorkAge",
      "label": "工龄"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "可登录",
      "prop": "canlogin"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "status",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success",
            "icon": "view"
          },
          on: {
            "click": function($event) {
              _vm.viewHandle(scope.row)
            }
          }
        }, [_vm._v("\n                    查看\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              _vm.editHandle(scope.row)
            }
          }
        }, [_vm._v("\n                    修改\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange2
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.TitleContent,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.addDialogClose
    },
    model: {
      value: (_vm.AddEmployeeVisible),
      callback: function($$v) {
        _vm.AddEmployeeVisible = $$v
      },
      expression: "AddEmployeeVisible"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.view) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "80px",
      "model": _vm.Form,
      "rules": _vm.rules
    }
  }, [_c('h4', [_vm._v("个人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.Name),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Name", $$v)
      },
      expression: "Form.Name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.Form.Sex),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Sex", $$v)
      },
      expression: "Form.Sex"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "男",
      "lable": "男"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "女",
      "label": "女"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.IdCard),
      callback: function($$v) {
        _vm.$set(_vm.Form, "IdCard", $$v)
      },
      expression: "Form.IdCard"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "生日",
      "prop": "Birthday",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticClass: "input-width",
    attrs: {
      "type": "date",
      "placeholder": "选择生日"
    },
    model: {
      value: (_vm.Form.Birthday),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Birthday", $$v)
      },
      expression: "Form.Birthday"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.Tel),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Tel", $$v)
      },
      expression: "Form.Tel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "毕业院校"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.Schools),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Schools", $$v)
      },
      expression: "Form.Schools"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学历"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.Education),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Education", $$v)
      },
      expression: "Form.Education"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.Professional),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Professional", $$v)
      },
      expression: "Form.Professional"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家庭地址"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.Address),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Address", $$v)
      },
      expression: "Form.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("工作信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.uid),
      callback: function($$v) {
        _vm.$set(_vm.Form, "uid", $$v)
      },
      expression: "Form.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "雇员编号"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.EmpCode),
      callback: function($$v) {
        _vm.$set(_vm.Form, "EmpCode", $$v)
      },
      expression: "Form.EmpCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeStadus
    },
    model: {
      value: (_vm.Form.Status),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Status", $$v)
      },
      expression: "Form.Status"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "正式员工"
    }
  }, [_vm._v("正式员工")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "试用期"
    }
  }, [_vm._v("试用期")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "实习"
    }
  }, [_vm._v("实习")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "离职"
    }
  }, [_vm._v("离职")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDisable),
      expression: "!isDisable"
    }],
    attrs: {
      "label": "离职日期",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticClass: "input-width",
    attrs: {
      "type": "date",
      "placeholder": "选择入职日期"
    },
    model: {
      value: (_vm.Form.LeaveDate),
      callback: function($$v) {
        _vm.$set(_vm.Form, "LeaveDate", $$v)
      },
      expression: "Form.LeaveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "required": ""
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.ActionPartment.D_Name) + "\n                            "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.view),
      expression: "!view"
    }],
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.actionPartment
    }
  }, [_vm._v("选择部门")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "直线经理"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.ActionEmployee.name) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入职日期",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticClass: "input-width",
    attrs: {
      "type": "date",
      "placeholder": "选择入职日期"
    },
    model: {
      value: (_vm.Form.EntryDate),
      callback: function($$v) {
        _vm.$set(_vm.Form, "EntryDate", $$v)
      },
      expression: "Form.EntryDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "员工属性",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.Form.EmployeeProperty),
      callback: function($$v) {
        _vm.$set(_vm.Form, "EmployeeProperty", $$v)
      },
      expression: "Form.EmployeeProperty"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "全职员工"
    }
  }, [_vm._v("全职员工")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "兼职员工"
    }
  }, [_vm._v("兼职员工")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工作地",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.WorkAddress),
      callback: function($$v) {
        _vm.$set(_vm.Form, "WorkAddress", $$v)
      },
      expression: "Form.WorkAddress"
    }
  }, _vm._l((_vm.WorkAddress), function(item) {
    return _c('el-option', {
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业邮箱"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.EntEmail),
      callback: function($$v) {
        _vm.$set(_vm.Form, "EntEmail", $$v)
      },
      expression: "Form.EntEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考勤卡"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.IMEI),
      callback: function($$v) {
        _vm.$set(_vm.Form, "IMEI", $$v)
      },
      expression: "Form.IMEI"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分机号"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.ExtNumber),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ExtNumber", $$v)
      },
      expression: "Form.ExtNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_vm._l((_vm.Form.LaborRelations), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": '劳动合同时间' + (index + 1)
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-date-picker', {
      staticClass: "input-width",
      attrs: {
        "type": "date"
      },
      model: {
        value: (_vm.Form.LaborRelations[index].StartDate),
        callback: function($$v) {
          _vm.$set(_vm.Form.LaborRelations[index], "StartDate", $$v)
        },
        expression: "Form.LaborRelations[index].StartDate"
      }
    }), _vm._v("\n                               至\n                        ")], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-date-picker', {
      staticClass: "input-width",
      attrs: {
        "type": "date"
      },
      model: {
        value: (_vm.Form.LaborRelations[index].EndDate),
        callback: function($$v) {
          _vm.$set(_vm.Form.LaborRelations[index], "EndDate", $$v)
        },
        expression: "Form.LaborRelations[index].EndDate"
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShow[index]),
        expression: "isShow[index]"
      }],
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDomain(item)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("新增劳动合同时间")])], 1)], 2), _vm._v(" "), _c('h4', [_vm._v("银行卡信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行名称"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.BankName),
      callback: function($$v) {
        _vm.$set(_vm.Form, "BankName", $$v)
      },
      expression: "Form.BankName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户行"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.BankOpenAddress),
      callback: function($$v) {
        _vm.$set(_vm.Form, "BankOpenAddress", $$v)
      },
      expression: "Form.BankOpenAddress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行卡号"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.BankNumber),
      callback: function($$v) {
        _vm.$set(_vm.Form, "BankNumber", $$v)
      },
      expression: "Form.BankNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("其他信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "可登陆"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.Form.CanLogin),
      callback: function($$v) {
        _vm.$set(_vm.Form, "CanLogin", $$v)
      },
      expression: "Form.CanLogin"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人员排序"
    }
  }, [_c('el-input', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.Sort),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Sort", $$v)
      },
      expression: "Form.Sort"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "隶属项目"
    }
  }, [_c('el-select', {
    staticClass: "input-width",
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.Form.Subjection),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Subjection", $$v)
      },
      expression: "Form.Subjection"
    }
  }, _vm._l((_vm.SubjectDemo), function(item) {
    return _c('el-option', {
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数据权限配置"
    }
  }, [_c('el-select', {
    staticClass: "input-width",
    model: {
      value: (_vm.Form.DataAuthority),
      callback: function($$v) {
        _vm.$set(_vm.Form, "DataAuthority", $$v)
      },
      expression: "Form.DataAuthority"
    }
  }, _vm._l((_vm.DataAuthoritys), function(item) {
    return _c('el-option', {
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限设置"
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("1、订单查询（APP订单）、代理商账号查询 、正式代理商 、正式幼儿园")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("按项目")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.Form.ModuleRoleList[0].ListProjectRole),
      callback: function($$v) {
        _vm.$set(_vm.Form.ModuleRoleList[0], "ListProjectRole", $$v)
      },
      expression: "Form.ModuleRoleList[0].ListProjectRole"
    }
  }, _vm._l((_vm.SubjectDemo), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', [_c('div', [_vm._v("按区域  \n                                        "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.selectArea
    }
  }, [_vm._v("选择")]), _vm._v("\n                                         \n                                        "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.clearCheckedAreaTxtHandle
    }
  }, [_vm._v("清空")])], 1), _vm._v(" "), _c('div', [_c('el-input', {
    staticClass: "com-textarea1",
    staticStyle: {
      "width": "91%"
    },
    attrs: {
      "type": "textarea",
      "readonly": true
    },
    model: {
      value: (_vm.provinceTextarea),
      callback: function($$v) {
        _vm.provinceTextarea = $$v
      },
      expression: "provinceTextarea"
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("2、招商/物料支持")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("按项目")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.Form.ModuleRoleList[1].ListProjectRole),
      callback: function($$v) {
        _vm.$set(_vm.Form.ModuleRoleList[1], "ListProjectRole", $$v)
      },
      expression: "Form.ModuleRoleList[1].ListProjectRole"
    }
  }, _vm._l((_vm.SubjectDemo), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("3、业绩")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("按项目")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.Form.ModuleRoleList[2].ListProjectRole),
      callback: function($$v) {
        _vm.$set(_vm.Form.ModuleRoleList[2], "ListProjectRole", $$v)
      },
      expression: "Form.ModuleRoleList[2].ListProjectRole"
    }
  }, _vm._l((_vm.SubjectDemo), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', [_c('el-checkbox-group', {
    model: {
      value: (_vm.checkedListBtnName),
      callback: function($$v) {
        _vm.checkedListBtnName = $$v
      },
      expression: "checkedListBtnName"
    }
  }, _vm._l((_vm.yjListBtnName), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item
      }
    })
  }))], 1)])])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "91%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.Form.Remarks),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Remarks", $$v)
      },
      expression: "Form.Remarks"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view),
      expression: "view"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDialogClose
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.view),
      expression: "!view"
    }],
    on: {
      "click": _vm.addDialogClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.view),
      expression: "!view"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.Submit('ruleForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)]), _vm._v(" "), _c('selectStaffDialog', {
    ref: "refSelectStaffDialog",
    on: {
      "selectedStaff": _vm.selectedStaff
    }
  }), _vm._v(" "), _c('selectAreaDialog', {
    ref: "refSelectAreaDialog",
    on: {
      "getCheckedNode": _vm.getSelectAreaCheckedNode
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择部门",
      "size": "tiny"
    },
    model: {
      value: (_vm.actionPartmentVisible),
      callback: function($$v) {
        _vm.actionPartmentVisible = $$v
      },
      expression: "actionPartmentVisible"
    }
  }, [_c('Tree', {
    ref: "tree",
    attrs: {
      "message": _vm.TreeDataList
    },
    on: {
      "NodeClick": _vm.handleActionPartment
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.actionPartmentVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.PartmentSure
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3855dbfa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personManage/EmployeeManage/EmployeeMange.vue
// module id = 1455
// module chunks = 1